<template>
  <div class="d-flex flex-row w-100 h-100">
    <div class="task-section d-flex flex-column px-4">
      <div class="d-flex flex-column">
        <div
          class="py-5 d-flex justify-space-between flex-wrap align-center"
          style="gap: 15px">
          <v-sheet>
            <span class="taskTypeTitle" v-if="currentTaskType">{{ currentTaskType.name }}</span>
          </v-sheet>
          <v-sheet
            :class="{
              'flex-grow-1': is3dOpened,
              'order-3': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md,
            }"
            :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '100%' : 250">
            <v-text-field
              class="customSearchBox"
              outlined
              rounded
              dense
              hide-details
              v-model="options.search"
              :loading="loading || linkUpdating"
              placeholder="Search..."
              append-icon="mdi-magnify"></v-text-field>
          </v-sheet>
          <v-sheet>
            <v-btn
              class="me-2 border-rounded rounded-md"
              :class="{ 'order-2': $vuetify.breakpoint.sm }"
              outlined
              @click="addProject()"
              color="primary"
             :disabled="!$has(permissions.TaskBoardProjects.Create)"
              v-if="$route.name !== 'schedule'"
              ><v-icon left>mdi-plus</v-icon> Add Project</v-btn
            >
            <v-btn
              @click="openTask()"
              color="primary"
              v-has="permissions.Tasks.Create"
              v-if="$route.name !== 'schedule'"
              ><v-icon left>mdi-plus</v-icon> Add Task</v-btn
            >
            <v-btn @click="openEvent()" color="primary" v-if="$route.name === 'schedule'"
              ><v-icon left>mdi-plus</v-icon> Add Event</v-btn
            >
          </v-sheet>
        </div>
        <v-divider style="width: 99%"></v-divider>
        <div
          class="d-flex align-center py-3 pe-4"
          :class="{
            'flex-column justify-center': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
            'justify-content-between': !$vuetify.breakpoint.xs || !$vuetify.breakpoint.sm,
          }">
          <v-tabs
            hide-slider
            class="task-tabs"
            :style="{ width: $vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 'auto' : '100%' }">
            <v-tab
              exact
              exact-active-class="activeTab"
              :disabled="!$has(tab.permissions)"
              v-for="tab in tabs"
              :to="tab.path"
              :key="tab.name + 1"
              @change="onTabChange(tab)"
            >
              <v-icon small left>{{ tab.icon }}</v-icon>
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <div
            class="actions d-flex"
            :class="{ 'pt-3': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }">
            <!-- {{ selectedTasks }} ---------- {{ collectionSelected }} -->
            <v-tooltip top v-if="$route.name === 'gantt' && collectionSelected" >
              <template v-slot:activator="{ on, attrs }">
                <span   v-bind="attrs"
                v-on="on">
                  <v-btn
                  :disabled="!$has(permissions.Tasks.Update)"
                  color="primary"
                  outlined
                  fab
                  small
                  class="mr-2 mb-0 toolbar-item"

                  @click="editSelectedGanttTasks">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                </span>

              </template>
              {{ $has(permissions.Tasks.Update)?'Edit Selected Tasks':'Permission Required' }}
            </v-tooltip>
            <v-tooltip top v-if="$route.name === 'gantt' && collectionSelected">
              <template v-slot:activator="{ on, attrs }">
                <span  v-bind="attrs"
                v-on="on">
                <v-btn
                 :disabled="!$has(permissions.Tasks.Delete)"
                  color="error"
                  outlined
                  fab
                  small
                  class="mr-2 mb-0 toolbar-item"

                  @click="deleteSelectedGanttTasks">
                  <v-icon small>fas fa-trash</v-icon>
                </v-btn>
                </span>

              </template>
            {{ $has(permissions.Tasks.Delete)?'Delete':'Permission Required' }}
            </v-tooltip>

            <v-tooltip top v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  color="primary"
                  class="mr-2"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  :outlined="!ganttToolbar.includes('resourcePanel')"
                  @click="ganttActionsClick('resourcePanel')">
                  <v-icon> mdi-layers-triple</v-icon>
                </v-btn>
              </template>

              Resource Panel
            </v-tooltip>
            <v-tooltip top v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  color="primary"
                  class="mr-2"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  :outlined="!ganttToolbar.includes('highlightCriticalPath')"
                  @click="ganttActionsClick('highlightCriticalPath')">
                  <v-icon>mdi-transit-connection-variant </v-icon>
                </v-btn>
              </template>

              Critical Path
            </v-tooltip>

            <v-tooltip top v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  :outlined="!ganttToolbar.includes('autoSchedule')"
                  fab
                  color="primary"
                  value="autoSchedule"
                  elevation="0"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="ganttActionsClick('autoSchedule')">
                  <v-icon x-small>fa-solid fa-calendar-week</v-icon>
                </v-btn>
              </template>
              Auto Schedule
            </v-tooltip>
            <v-tooltip top v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  outlined
                  fab
                  color="primary"
                  class="mr-2 mb-0 toolbar-item"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  @click="zoomAction">
                  <v-icon>mdi-fit-to-screen-outline</v-icon>
                </v-btn>
              </template>
              Zoom To Fit
            </v-tooltip>

            <v-menu offset-y bottom v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="primary"
                  v-bind="attrs"
                  class="me-2 mb-0"
                  v-on="on"
                  style="margin-bottom: 10px">
                  Scale <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item-group v-model="selectedScaleOption">
                  <v-list-item v-for="item in scaleOptions" :key="item.value" :value="item.value">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <v-btn
              v-if="($route.name === 'kanban' || $route.name === 'list') && canShowTasksIn3d"
              color="primary"
              outlined
              @click="showAllTasksIn3d"
              class="mx-2">
              <v-icon left>mdi-cube-outline</v-icon> Isolate All
            </v-btn>
            <v-badge
              :value="activeFilterCount > 0"
              :content="activeFilterCount"
              color="error"
              overlap
              offset-x="10"
              offset-y="10">
              <v-btn color="primary" outlined @click="openFilters">
                <v-icon left>{{ activeFilterCount > 0 ? 'mdi-filter-check' : 'mdi-filter' }}</v-icon> Filters
              </v-btn>
            </v-badge>
          </div>
        </div>
      </div>
      <keep-alive>
        <router-view
          class="flex-grow-1"
          :include="['app-gantt', 'app-kanban', 'app-scheduler','app-task-board-charts']"
          v-show="!loadType"
          ref="dhtmlx"
          :ganttToolbar="ganttToolbar"
          :selectedScaleOption="selectedScaleOption"
          @collectionSelected="updateCollectionSelected"
          :currentTaskType="currentTaskType"
          @updateViewerStatusColors="updateViewerStatusColors"
          @edit-completed="handleEditComplete($event)"></router-view>
      </keep-alive>

      <EditTask ref="editTask"></EditTask>
      <EditProject ref="editProject"></EditProject>
      <TaskFilters ref="taskFilters"></TaskFilters>
      <RecurringEvent ref="recurringEvent"></RecurringEvent>
    </div>
    <v-sheet
      v-show="viewerOpened"
      class="task-viewers-section-wrapper"
      style="width: 30vw; min-width: 400px; flex-shrink: 0;">
      <ViewersSection
        ref="viewersSection"
        feature="task"
        :enabledTabs="['3D View', '2D View', '360 View']"
        :viewerTab.sync="viewerTab"
        :usePhotoSphereViewer="false"
        @closeViewersSection="onCloseViewer"
        @tab-changed="onTabChanged"
        @expand="onExpandViewer">
        <template #viewer-overlay="{ activeTab }">
          <ViewerTaskColoring
            v-if="activeTab === '3D View'"
            ref="viewerTaskColoring"
            :isolation-info-by-task-id="taskIsolationInfoByTaskId"
            :isolated-tags="isolatedTagsForViewer" />
        </template>
        <template #header-controls="{ activeTab }">
          <!--
            Phase 3 — Compact icon-button + corner badge pattern (per design feedback).
            Visible on kanban route + 3D tab when tasks are isolated. Matches the visual
            weight of the surrounding expand/close buttons (icon-only chrome) and uses
            the universal notification-badge pattern for the count. The icon
            (mdi-vector-selection) reads as "items currently isolated in the viewer."
            Clicking opens IsolatedTagsDialog with the isolated tags.
          -->
          <button
            v-if="activeTab === '3D View' && $route.name === 'kanban' && isolatedTasks.length > 0"
            type="button"
            class="task-header-isolated-btn"
            :aria-label="`${isolatedTasks.length} ${isolatedTasks.length === 1 ? 'task' : 'tasks'} isolated — click to view list`"
            :title="`${isolatedTasks.length} ${isolatedTasks.length === 1 ? 'task' : 'tasks'} isolated`"
            @click="taskIsolatedDialogOpen = true">
            <v-icon size="18" class="task-header-isolated-btn__icon">mdi-vector-selection</v-icon>
            <span class="task-header-isolated-btn__badge" aria-hidden="true">
              {{ isolatedTasks.length > 99 ? '99+' : isolatedTasks.length }}
            </span>
          </button>
        </template>
      </ViewersSection>
      <IsolatedTagsDialog
        v-model="taskIsolatedDialogOpen"
        :items="isolatedTagsForViewer"
        title="Isolated Tags"
        footer-text="Tags currently isolated in the 3D viewer"
        @close="taskIsolatedDialogOpen = false" />
    </v-sheet>
  </div>
</template>

<script>
  // @workflow tasks.show-in-3d
  // import UserAvatar from '@Share/components/UserAvatar.vue';
  // import generalSelector from '@Share/components/generalSelector.vue';
  import EditTask from '../components/EditTask.vue';
  // Phase 3 of TaskBoard viewer migration: switched from feature-owned wrapper
  // (TaskViewerSection) to the shared multi-modal Dashboard/ViewersSection.
  // The slot-rendered ViewerTaskColoring stays mounted only on the 3D tab; the
  // tab-changed event drives 2D-plan and 360-panorama transitions.
  import ViewersSection from '@Dashboard/components/ViewersSection.vue';
  import ViewerTaskColoring from '../components/ViewerTaskColoring.vue';
  import IsolatedTagsDialog from '@Share/components/IsolatedTagsDialog.vue';
  import { log, error as debugError } from '@/utils/debugLogger';
  import EditProject from '@Contract/components/EditProject.vue';
  import TaskFilters from '../components/TaskFilters.vue';
  import { mapGetters } from 'vuex';
  import permissions from '@Share/config/permissions';
  import { TaskFieldType } from '@Share/config/enums';
  import RecurringEvent from '@/features/Task/components/RecurringEvent.vue';
  import { $has } from '@/utils';
  import { showTasksInViewer } from '@/actions/tasks';
  import { loadTaskViewerTab } from '@/actions/taskViewerPanel';
  import { createTaskViewerSeam } from '@/actions/taskViewerSeam';
  import { registerTaskBoardSurface } from '@/actions/taskBoardSurface';
  import { registerPageViewer } from '@/platform/viewer';
  import { TASK_VIEWER_TAB } from '@/actions/taskContract';
  import { CAPABILITY, can } from '@/actions/permissions';
  import { EventBus, TASK_EVENTS } from '@/event-bus';
  import { taskIdsForBoard } from '@Task/utils/taskPatch';

  /** The board's 360 viewer element (ViewersSection loadPannellumViewer). */
  const PANNELLUM_VIEWER_ID = 'pannellum-viewer';
  /** How long a back-from-expand restore waits for the first show to take it over. */
  const RESTORE_GUARD_MS = 3000;

  export default {
    name: 'main-task',
    data() {
      return {
        // Initial base filters. getTaskType() rebuilds this on every board load
        // (base filters with current-board URLs + the board's custom fields), so
        // these URLs are placeholders only — kept non-empty because
        // preloadFilterOptions() is guarded by `filters.length > 0`.
        filters: [
          {
            label: 'Contract',
            placeholder: 'Contract',
            prop: 'contractId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/contractId`,
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Project',
            placeholder: 'Project',
            prop: 'projectId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/projectId`,
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Status',
            placeholder: 'Status',
            prop: 'statusId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/statusId`,
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Participants',
            placeholder: 'Participants',
            prop: 'participantId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/participantId`,
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Approved By',
            placeholder: 'Approved By',
            prop: 'approvedById',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/approvedById`,
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Reported By',
            placeholder: 'Reported By',
            prop: 'reportedById',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/reportedById`,
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Project Manager',
            placeholder: 'Project Manager',
            prop: 'projectManager',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/projectManager`,
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'WBS element ID',
            placeholder: 'WBS element ID',
            prop: 'wbsElementId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/wbsElementId`,
            itemText: 'name',
            itemValue: 'id',
          },
        ],
        loadType: false,
        selectedFilter: [0],
        timerId: null,
        permissions,
        is3dOpened: false,
        TaskFieldType,
        // Base filter metadata. NOTE: the option-source `url` is intentionally
        // NOT defined here — it is built per-board in getTaskType() against the
        // CURRENT taskTypeId. data() runs only once (index.vue is the persistent
        // parent route component, reused across taskTypeId changes), so embedding
        // the taskTypeId here would freeze it to the first board opened and make
        // Status/Contract/etc. always load the first board's options. The url
        // segment equals each filter's `prop`.
        tempFilters: [
          {
            label: 'Contract',
            placeholder: 'Contract',
            prop: 'contractId',
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Project',
            placeholder: 'Project',
            prop: 'projectId',
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Status',
            placeholder: 'Status',
            prop: 'statusId',
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Participants',
            placeholder: 'Participants',
            prop: 'participantId',
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Approved By',
            placeholder: 'Approved By',
            prop: 'approvedById',
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Reported By',
            placeholder: 'Reported By',
            prop: 'reportedById',
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Project Manager',
            placeholder: 'Project Manager',
            prop: 'projectManager',
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'WBS element ID',
            placeholder: 'WBS element ID',
            prop: 'wbsElementId',
            itemText: 'name',
            itemValue: 'id',
          },
        ],
        ganttToolbar: [],
        collectionSelected: false,
        selectedScaleOption: 'day',
        scaleOptions: [
          { name: 'Day', value: 'day' },
          { name: 'Week', value: 'week' },
          { name: 'Yearly Quarter', value: 'quarter' },
          { name: 'Year', value: 'year' },
        ],
        // Phase 3 of TaskBoard viewer migration — local state replacing the
        // imperative open/close pattern of the old TaskViewerSection wrapper.
        // Mirrors the Registers/views/index.vue convention.
        viewerOpened: false,
        viewerTab: TASK_VIEWER_TAB.MODEL_3D,
        // Tags of the currently isolated tasks, set by the show-tasks action
        // (actions/tasks.js, through this board's surface) and read by the
        // per-tab viewer steps (actions/taskViewerPanel.js).
        isolatedTagsForViewer: [],
        // Normalized server plans for the currently isolated tasks. Kept
        // separate from task.forgeTagsIds so monitoring D3 remains intact.
        taskIsolationInfoByTaskId: {},
        // Phase 3 — preserves the "X Tasks Isolated" button + dialog from the
        // old TaskViewerSection wrapper. The button shows on the kanban route
        // (matching the old visibility rule) and renders into the shared
        // ViewersSection's viewer-sidebar slot.
        taskIsolatedDialogOpen: false,
      };
    },
    computed: {
      ...mapGetters('TASK', { loading: 'GET_LOADING', entries: 'GET_TASKS' }),
      ...mapGetters('LINK', { linkUpdating: 'GET_UPDATE_LOADING' }),
      currentTaskType: {
        get() {
          return this.$store.getters['TASK_MANAGER/GET_CURRENT_TASK_TYPE'];
        },
        set(value) {
          this.$store.commit('TASK_MANAGER/SET_CURRENT_TASK_TYPE', value);
        },
      },
      activeFilters() {
        return this.selectedFilter.map((index) => this.filters[index]);
      },
      options: {
        get() {
          return this.$store.getters['TASK/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('TASK/SET_OPTIONS', val);
        },
      },
      isolatedTasks: {
        get() {
          return this.$store.getters['TASK/GET_ISOLATED_TASKS'];
        },
        set(value) {
          this.$store.commit('TASK/SET_ISOLATED_TASKS', value);
        },
      },
      tabs() {
        return [
          // {
          //   name: 'Tasks',
          //   icon: 'mdi-file-tree',
          //   path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}`,
          // },
          {
            name: 'Board',
            icon: 'mdi-billboard',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/`,
            permissions: [permissions.TaskTracker.View],
          },
          {
            name: 'List',
            icon: 'mdi-table',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/list`,
            permissions: [permissions.TaskTracker.View],
          },
          {
            name: 'Gantt',
            icon: 'mdi-chart-gantt',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/gantt`,
            permissions: [permissions.Gantt.View],
          },
          {
            name: 'Schedule',
            icon: 'mdi-calendar-clock',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/schedule`,
            permissions: [permissions.Scheduler.View],
          },
          {
            name: 'Charts',
            icon: 'mdi-calendar-clock',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/task-board-charts`,
            permissions: [permissions.TaskTracker.View],
          },
        ];
      },
      selectedTasks: {
        get() {
          return this.$store.getters['GANTT/GET_SELECTED_TASKS'];
        },
        set(val) {
          this.$store.commit('GANTT/SET_SELECTED_TASKS', val);
        },
      },
      /** Show tasks in 3D (Isolate All): the permission map (actions/permissions.js). */
      canShowTasksIn3d() {
        return can(CAPABILITY.TASKS_SHOW_IN_3D, this.$store);
      },
      activeFilterCount() {
        // Count the number of filters that have at least one selection
        if (!this.options) return 0;
        return Object.values(this.options).filter((arr) => Array.isArray(arr) && arr.length > 0).length;
      },
    },
    created() {
      // The task actions and the assistant reach this board's viewer panel through it. Registered
      // before the child views (Kanban, List, …) mount, so a show they start at once finds it.
      this._unregisterViewerSurface = registerTaskBoardSurface(this.viewerSurface());
      // The assistant's viewer tools use this board's 3D panel instead of leaving for the facility view.
      this._unregisterPageViewer = registerPageViewer({
        facilityId: () => this.$route.params.id || null,
        is3dOpen: () => this.viewerOpened && this.viewerTab === TASK_VIEWER_TAB.MODEL_3D,
        open3d: () => this.openPanelOn3dForAssistant(),
      });
      // AVA changed tasks (AVA-755): this board patches the ones it shows.
      EventBus.$on(TASK_EVENTS.CHANGED, this.onTasksChanged);
    },
    mounted() {
      log('[TaskBoard/mounted] entered, pendingRestore=', this.$store.state.VIEWERS_MODE?.pendingRestore);
      this.$store.dispatch('PROJECT/GET');
      this.$store.commit('SET_VIEWER_TYPE', '2d');
      // this.$store.dispatch('TASK_MANAGER/GET');
      //this.$store.dispatch('USER/GET');
      // this.$store.dispatch('TASKSTATUS/GET');

      // Issue 2 fix: if returning from a 360° expand, reconstruct the inline
      // viewer state (panel + tab + isolated task + scan).
      log('[TaskBoard/mounted] about to call _consumePendingRestoreIfAny');
      this._consumePendingRestoreIfAny();
    },
    beforeDestroy() {
      EventBus.$off(TASK_EVENTS.CHANGED, this.onTasksChanged);
      if (this._unregisterViewerSurface) {
        this._unregisterViewerSurface();
        this._unregisterViewerSurface = null;
      }
      if (this._unregisterPageViewer) {
        this._unregisterPageViewer();
        this._unregisterPageViewer = null;
      }
      // Cancel the restoration safety-net timer if pending. Prevents the timer
      // callback from firing on a destroyed instance (would log spuriously and
      // touch detached `this` references).
      if (this._restoreFlagClearTimer) {
        clearTimeout(this._restoreFlagClearTimer);
        this._restoreFlagClearTimer = null;
      }
    },
    methods: {
      $has,
      openTask(isBult = false) {
        let today = new Date().toISOString();
        let task = {
          text: '',
          start_date: today,
          end_date: today,
          actualStartDate: null,
          actualEndDate: null,
        };
        let payLoad = {
          task,
          isNew: true,
          fromIndexPage: true,
          taskTypeId: this.$route.params.taskTypeId,
          isBulk: isBult,
        };
        this.$refs.editTask.open(payLoad);
      },
      openEvent() {
        this.$refs.recurringEvent.openDialog();
      },
      /** The query of the board's task list: every load of this board reads the same one. */
      boardLoadOptions() {
        return {
          typeId: this.$route.params.taskTypeId,
          sortBy: 'GanttOrder',
          // sortBy: this.$route.name === 'kanban' ? 'KanbanOrder' : 'GanttOrder',
        };
      },
      getDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.$store.dispatch('TASK/GET_DATA', this.boardLoadOptions());

          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.$store.dispatch('TASK/GET_DATA', this.boardLoadOptions());
        }, 400);
      },
      /**
       * AVA changed tasks (AVA-755, announced by the assistant's receiver). The ones on this board are read and
       * patched in place (TASK/PATCH_CHANGED); when a patch could be wrong the list is read again without the
       * loading line. The view on screen then shows them (Kanban: highlight, and scroll when one is off screen).
       * An open Edit task keeps its own copy of the task, so unsaved edits are never touched.
       */
      async onTasksChanged({ tasks } = {}) {
        const boardId = this.$route.params.taskTypeId;
        const ids = taskIdsForBoard(tasks, boardId);
        if (ids.length === 0) return;
        const view = this.$refs.dhtmlx;
        const showsChanges = view && typeof view.showChangedTasks === 'function';
        try {
          if (showsChanges) view.holdScrollForChanges();
          const patch = await this.$store.dispatch('TASK/PATCH_CHANGED', { boardId, ids });
          if (patch.refetch) await this.$store.dispatch('TASK/GET_DATA_QUIETLY', this.boardLoadOptions());
          // A timer, not nextTick: the patch redraws the cards on a timer (task.modules.js updateComponents),
          // and timers run in order, so the cards are in place when they are shown.
          if (showsChanges && patch.ids.length > 0) setTimeout(() => view.showChangedTasks(patch.ids));
        } catch (err) {
          debugError('TaskBoard', 'Could not show the tasks AVA changed', err);
        }
      },
      getTaskType(id) {
        this.loadType = true;
        // Rebuild base-filter option URLs against the CURRENT board (the url segment
        // equals each filter's `prop`). Assigned SYNCHRONOUSLY here — before the async
        // task-type fetch — so a data load that completes first never preloads stale
        // (previous-board) base-filter options. These URLs can't live in data(): it
        // runs once for this persistent parent component and would freeze the first
        // board's taskTypeId.
        const typeId = this.$route.params.taskTypeId;
        const baseFilters = this.tempFilters.map((f) => ({
          ...f,
          url: `/api/Tasks/Filters/${typeId}/${f.prop}`,
          category: 'General',
        }));
        this.filters = baseFilters;
        this.$store
          .dispatch('TASK_MANAGER/GET_BY_ID', id)
          .then((res) => {
            // Ignore a stale resolution: if the user switched boards again while
            // this fetch was in flight, a newer getTaskType() is authoritative —
            // don't clobber its state with this (old) board's data.
            if (typeId !== this.$route.params.taskTypeId) return;
            this.currentTaskType = res;
            // Append the board's custom-field filters (base filters already set above).
            const withCustomFields = [...baseFilters];
            this.currentTaskType.sections.forEach((section) => {
              section.fields.forEach((field) => {
                let additionField = {
                  label: field.label,
                  placeholder: field.placeHolder,
                  // `fieldId` = stable raw field id (grouping + display-value lookup);
                  // `prop` = final data-request key (was rewritten on load before).
                  fieldId: field.id,
                  prop: `customFields[${field.id}]`,
                  url: `/api/Tasks/Filters/${typeId}/${field.id}`,
                  itemText: field.value,
                  // Option objects are keyed by `id` (see loadSingleFilterOptions);
                  // the field UUID lives in `fieldId`. itemValue must be 'id' so the
                  // autocomplete stores/reads the option id, not option[<uuid>].
                  itemValue: 'id',
                  category: section.name,
                };
                if (field.fieldType == TaskFieldType.Users) additionField['type'] = 'userList';
                withCustomFields.push(additionField);
              });
            });
            this.filters = withCustomFields;
          })
          .finally(() => {
            this.loadType = false;
          });
      },
      /**
       * This board's viewer panel as the task actions use it (actions/taskBoardSurface.js):
       * show-tasks hands it the tags and the tab, the per-tab steps load its viewers.
       */
      viewerSurface() {
        if (!this._viewerSurface) {
          this._viewerSurface = Object.freeze({
            facilityId: () => this.$route.params.id || null,
            setIsolationInfo: (infoByTaskId) => {
              this.taskIsolationInfoByTaskId = infoByTaskId;
            },
            present: (scene) => this.presentTaskScene(scene),
            load3d: () => this.$refs.viewersSection?.load3dViewer?.(),
            load2d: (planUrn) => this.$refs.viewersSection?.load2dViewer?.(planUrn),
            load360: (image, tag) => this.$refs.viewersSection?.loadPannellumViewer?.(image, tag, PANNELLUM_VIEWER_ID),
            paint3d: () => this.paintTaskScene(),
            nextTick: () => this.$nextTick(),
            notify: Object.freeze({
              warning: (text) => this.$dialog?.notify?.warning?.(text),
              error: (text) => this.$dialog?.notify?.error?.(text),
            }),
          });
        }
        return this._viewerSurface;
      },
      /** What the per-tab viewer steps need: the store, this panel, and the viewer seam. */
      viewerContext() {
        if (!this._viewerContext) {
          this._viewerContext = Object.freeze({
            store: this.$store,
            surface: this.viewerSurface(),
            viewer: createTaskViewerSeam(this.$store),
          });
        }
        return this._viewerContext;
      },
      /**
       * The assistant shows its own tags here: the board's task scene is ended first (its colouring
       * repaints on its own watchers and would cover the assistant's), then the panel opens on 3D
       * and loads the model. With no tasks to show, the tab watcher loads nothing itself.
       */
      async openPanelOn3dForAssistant() {
        this.isolatedTagsForViewer = [];
        this.taskIsolationInfoByTaskId = {};
        this.$store.commit('TASK/SET_ISOLATED_TASKS', []);
        if (this.$store.state.viewer) this.$refs.viewerTaskColoring?.endMode?.();
        this.is3dOpened = true;
        this.viewerOpened = true;
        this.viewerTab = TASK_VIEWER_TAB.MODEL_3D;
        await this.$nextTick();
        return this.$refs.viewersSection?.load3dViewer?.({ propagateErrors: true });
      },
      /** Choose the colour encoding, then render the whole scene once through the one authority. */
      async paintTaskScene() {
        this.$refs.viewerTaskColoring?.checkCriticalPath?.();
        await this.$refs.viewerTaskColoring?.applyColoringNow?.();
      },
      /**
       * Open the panel on the tasks' tags, on `tab`. The viewerTab watcher then runs that tab's
       * step (loadViewerForCurrentTab).
       */
      presentTaskScene({ tags, tab }) {
        this.isolatedTagsForViewer = tags;
        this.is3dOpened = true;
        this.viewerOpened = true;

        // Restoration guard: if we just back-navigated from a fullscreen 360°
        // expand, _consumePendingRestoreIfAny has already set viewerTab to the
        // user's prior tab ('360 View'). Don't clobber it — just re-run
        // isolation on the restored tab. Consumes the flag and cancels the
        // safety-net timer in one shot.
        if (this._isRestoringFromExpand) {
          this._isRestoringFromExpand = false;
          if (this._restoreFlagClearTimer) {
            clearTimeout(this._restoreFlagClearTimer);
            this._restoreFlagClearTimer = null;
          }
          log(`TaskBoard: show tasks keeps the restored tab (tab=${this.viewerTab})`);
          this.$nextTick(() => this.loadViewerForCurrentTab());
          return;
        }

        log(`TaskBoard: show tasks targetTab=${tab} (tagsCount=${tags.length})`);
        if (this.viewerTab === tab) {
          // Watcher won't fire if value is unchanged — invoke directly.
          this.$nextTick(() => this.loadViewerForCurrentTab());
        } else {
          this.viewerTab = tab;
        }
      },
      updateViewerStatusColors() {
        // TASK/MOVE updates the store silently, so its completion event must
        // trigger the repaint that reactive watchers cannot observe.
        const viewer = this.$store.state.viewer;
        if (!viewer) return;
        this.$refs.viewerTaskColoring?.onOptionChange?.();
      },
      addProject() {
        this.$refs.editProject.open(null, true);
      },
      onTabChange(tab) {
        if (tab.name === 'Gantt Chart') {
          this.$store.commit('GANTT/SET_RENDER_GANTT', true);
        } else if (tab.name === 'Schedule') {
          this.$store.commit('SCHEDULER/SET_RENDER_SCHEDULER', true);
        }
      },
      onCloseViewer() {
        // Migrated from old TaskViewerSection.onClosing — reset all Task viewer
        // state and tear down the coloring side effects. The shared component
        // emits 'closeViewersSection' (no boolean payload), so we drop the
        // legacy isClosed argument.
        this.is3dOpened = false;
        this.viewerOpened = false;
        this.isolatedTagsForViewer = [];
        this.taskIsolationInfoByTaskId = {};
        this.$store.commit('TASK/SET_ISOLATED_TASKS', []);
        this.$store.commit('SET_VIEWER_TYPE', '2d');
        this.$store.commit('GANTT/SET_RENDER_GANTT', true);
        this.$store.commit('SCHEDULER/SET_RENDER_SCHEDULER', true);
        this.$refs.viewerTaskColoring?.endMode?.();
      },
      /** Isolate All: the tasks the open view shows (the List's page; on Kanban, the board). */
      showAllTasksIn3d() {
        const view = this.$refs.dhtmlx;
        const tasks = typeof view?.tasksOnScreen === 'function' ? view.tasksOnScreen() : this.entries;
        showTasksInViewer({ store: this.$store, surface: this.viewerSurface() }, { tasks, statusId: null });
      },
      openFilters() {
        this.$refs.taskFilters.open(this.filters);
      },
      ganttActionsClick(action) {
        if (this.ganttToolbar.length > 0) {
          const index = this.ganttToolbar.indexOf(action);
          if (index !== -1) {
            this.ganttToolbar.splice(index, 1); // Remove the action if it exists
          } else {
            this.ganttToolbar.push(action); // Add the action if it doesn't exist
          }
        } else {
          this.ganttToolbar.push(action);
        }
      },
      zoomAction() {
        this.$refs.dhtmlx.zoomToFit();
      },
      updateCollectionSelected(value) {
        this.collectionSelected = value;
      },
      deleteSelectedGanttTasks() {
        this.$refs.dhtmlx.deleteSelectedTasks();
      },
      handleEditComplete() {
        // Filters will be loaded on-demand when TaskFilters opens
      },
      editSelectedGanttTasks() {
        let isBult = true;
        this.openTask(isBult);
      },

      /**
       * Run the current tab's viewer step (actions/taskViewerPanel.js) on the isolated tags.
       * Triggered by the viewerTab watcher, by show-tasks and by the back-from-expand restore.
       */
      loadViewerForCurrentTab() {
        if (!this.viewerOpened) return;
        if (!this.isolatedTagsForViewer.length) return;
        loadTaskViewerTab(this.viewerContext(), this.viewerTab, this.isolatedTagsForViewer);
      },

      /**
       * Phase 3 — Tab-changed observability hook. The viewerTab watcher already
       * triggers the per-tab load; this handler is reserved for future cross-cutting
       * concerns (analytics, breadcrumb updates).
       */
      onTabChanged(newTab, prevTab) {
        log(`TaskBoard: viewer tab changed ${prevTab} -> ${newTab}`);
      },

      /**
       * Override ViewersSection's default fullscreen dispatch with Task-aware
       * routing: task-coloring mode for 3D (coloring overlay is useful), default
       * fullscreen mode for 2D and 360° (no useful overlay there). Back
       * navigation always returns to TaskBoard.
       */
      onExpandViewer({ activeTab, panoramaTransfer }) {
        log(
          `TaskBoard: expand requested from tab ${activeTab}, panoramaTransfer=` +
            (panoramaTransfer ? JSON.stringify(panoramaTransfer) : 'null'),
        );

        const VIEWER_TYPE_BY_TAB = {
          [TASK_VIEWER_TAB.MODEL_3D]: '3d',
          [TASK_VIEWER_TAB.PLAN_2D]: '2d',
          [TASK_VIEWER_TAB.PANORAMA]: '360',
        };

        // Issue 2 fix: capture inline state for back-restore. For 360° expand,
        // user expects panel + 360° tab + isolated task(s) restored on return.
        const taskRestore =
          activeTab === TASK_VIEWER_TAB.PANORAMA
            ? {
                viewerTab: activeTab,
                forgeTagsIds: this.isolatedTagsForViewer.map((t) => t.id),
              }
            : null;

        this.$store.dispatch('VIEWERS_MODE/START_VIEWER_MODE', {
          mode: activeTab === TASK_VIEWER_TAB.MODEL_3D ? 'task-coloring' : 'dashboard-fullscreen',
          button: this.$route.name === 'kanban' ? 'Back to Kanban' : 'Back to Task Board Charts',
          viewer: VIEWER_TYPE_BY_TAB[activeTab],
          metadata: {
            taskTypeId: this.$route.params.taskTypeId,
            viewerMode: 'tasks',
            taskRestore,
          },
          panoramaTransfer,
        });
      },
      /**
       * Consume pendingRestore on TaskBoard mount after a back navigation from
       * a fullscreen viewer (expand button OR share-intent deep link).
       * Reconstructs the inline viewer state — panel open, correct tab (3D or
       * 360°), correct isolation — so the user returns to a fully-restored
       * TaskBoard view.
       *
       * Generalized from the original 360°-only version: now handles both
       * '3D View' and '360 View' restoration. The downstream
       * loadViewerForCurrentTab → per-tab step (actions/taskViewerPanel.js) chain handles
       * the actual viewer-side work.
       */
      async _consumePendingRestoreIfAny() {
        const restore = this.$store.state.VIEWERS_MODE?.pendingRestore;
        log('[TaskBoard/_consumePendingRestoreIfAny] entered, restore=', restore);

        const SUPPORTED_TABS = [TASK_VIEWER_TAB.MODEL_3D, TASK_VIEWER_TAB.PANORAMA];
        if (
          !restore ||
          !SUPPORTED_TABS.includes(restore.viewerTab) ||
          !restore.forgeTagsIds?.length
        ) {
          log('[TaskBoard/_consumePendingRestoreIfAny] gate failed — skipping');
          return;
        }

        log(
          `[TaskBoard/_consumePendingRestoreIfAny] consuming — tab=${restore.viewerTab}, tagIds=${restore.forgeTagsIds.length}`,
        );

        try {
          const fullTags = await this.$store.dispatch(
            'GET_BASE_TAGS_BY_IDS',
            restore.forgeTagsIds,
          );
          log('[TaskBoard/_consumePendingRestoreIfAny] tags fetched, count=',
            Array.isArray(fullTags) ? fullTags.length : 'N/A');
          this.isolatedTagsForViewer = Array.isArray(fullTags) ? fullTags : [];

          // Arm the guard so Kanban auto-isolation (which fires shortly after
          // mount via the Kanban entries watcher → showTasksInViewer) doesn't
          // clobber our restored viewerTab. Consumed by presentTaskScene.
          this._isRestoringFromExpand = true;
          log('[TaskBoard/_consumePendingRestoreIfAny] armed _isRestoringFromExpand guard');

          // Safety net: if no show consumes the flag within RESTORE_GUARD_MS
          // (e.g., user back-navigated to a non-Kanban subroute that doesn't
          // auto-isolate), auto-clear so a future legitimate show isn't affected.
          if (this._restoreFlagClearTimer) clearTimeout(this._restoreFlagClearTimer);
          this._restoreFlagClearTimer = setTimeout(() => {
            if (this._isRestoringFromExpand) {
              this._isRestoringFromExpand = false;
              log('[TaskBoard/_consumePendingRestoreIfAny] safety: auto-cleared _isRestoringFromExpand guard after 3s');
            }
            this._restoreFlagClearTimer = null;
          }, RESTORE_GUARD_MS);

          this.viewerTab = restore.viewerTab;
          this.viewerOpened = true;
          log(`[TaskBoard/_consumePendingRestoreIfAny] state set: viewerTab=${this.viewerTab}, viewerOpened=true`);

          await this.$nextTick();
          log('[TaskBoard/_consumePendingRestoreIfAny] post-nextTick, viewerTab=', this.viewerTab,
            'viewerOpened=', this.viewerOpened, 'calling loadViewerForCurrentTab');
          this.loadViewerForCurrentTab();
        } catch (err) {
          debugError('[TaskBoard/_consumePendingRestoreIfAny] failed', err);
        } finally {
          this.$store.commit('VIEWERS_MODE/setPendingRestore', null);
          log('[TaskBoard/_consumePendingRestoreIfAny] done — pendingRestore cleared');
        }
      },
    },
    components: {
      // generalSelector,
      // UserAvatar,
      EditTask,
      ViewersSection,
      ViewerTaskColoring,
      IsolatedTagsDialog,
      EditProject,
      TaskFilters,
      RecurringEvent,
    },
    watch: {
      $route: {
        immediate: true,
        deep: true,
        handler(val, oldVal) {
          if (val.params.taskTypeId) {
            if (
              oldVal &&
              oldVal.params.taskTypeId &&
              oldVal.params.taskTypeId == val.params.taskTypeId
            ) {
              return;
            }

            // Cache check: if entries are already populated for THIS taskTypeId
            // (e.g., user round-tripped from a deep-link → fullscreen → back),
            // skip the heavy refetch. This avoids re-loading projects, custom
            // fields, and task data when nothing has changed. Cleared by
            // TASK/CLEAR which only fires on actual taskTypeId change.
            const lastLoadedTaskTypeId = this.$store.state.TASK?.lastLoadedTaskTypeId;
            const entriesItems = this.$store.state.TASK?.entries?.tasks?.items;
            const hasCachedEntries =
              lastLoadedTaskTypeId === val.params.taskTypeId &&
              Array.isArray(entriesItems) &&
              entriesItems.length > 0;
            if (hasCachedEntries) {
              log(`[TaskBoard/$route] skipping refetch — entries already loaded for taskTypeId=${val.params.taskTypeId}`);
              // Still ensure currentTaskType is populated (used by chrome).
              if (!this.currentTaskType || this.currentTaskType.id !== val.params.taskTypeId) {
                this.getTaskType(val.params.taskTypeId);
              }
              return;
            }

            this.getTaskType(val.params.taskTypeId);
            log(`[TaskBoard/$route] board switch → resetting filters for taskTypeId=${val.params.taskTypeId}`);
            this.$store.dispatch('TASK/CLEAR');
            this.getDataDebounced();
          }
        },
      },
      options: {
        deep: true,
        handler() {
          this.getDataDebounced();
        },
      },
      // Phase 3 of TaskBoard viewer migration — cross-viewer transitions are
      // driven by tab changes. Mirrors Registers/views/index.vue.viewerTab watcher.
      viewerTab() {
        if (this.viewerOpened) {
          this.loadViewerForCurrentTab();
        }
      },
    },
  };
</script>
<style lang="scss">
  .taskTypeTitle {
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    letter-spacing: -0.01em;
    text-align: left;
  }
  // Task Board Tabs - Pill-shaped design matching reference UI
  .task-tabs {
    .v-tabs-bar {
      height: auto;
      background: transparent !important;
    }

    .v-tab {
      border-radius: 8px;
      height: 40px;
      min-width: auto;
      padding: 0 16px;
      margin-right: 8px;
      text-transform: none;
      font-weight: 500;
      font-size: 13px;
      letter-spacing: 0;

      // Smooth state transitions
      transition: all 0.2s ease;

      // Inactive state (light mode default)
      background-color: #f5f5f5;
      border: 1px solid #e0e0e0;
      color: #666 !important;

      .v-icon {
        color: #666 !important;
        margin-right: 6px;
      }

      &:hover:not(.v-tab--active):not(.activeTab) {
        background-color: #eeeeee;
        border-color: #d0d0d0;
      }

      // Disabled state
      &.v-tab--disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }

    // Active tab - outlined teal style matching reference design
    .v-tab--active,
    .v-tab.activeTab {
      font-weight: bold;
      border: 2px solid var(--v-primary-base) !important;
      color: var(--v-primary-base) !important;

      .v-icon {
        color: var(--v-primary-base) !important;
      }
    }
  }

  // Dark theme support for task tabs
  .theme--dark .task-tabs {
    .v-tab {
      background-color: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.12);
      color: rgba(255, 255, 255, 0.7) !important;

      .v-icon {
        color: rgba(255, 255, 255, 0.7) !important;
      }

      &:hover:not(.v-tab--active):not(.activeTab) {
        background-color: rgba(255, 255, 255, 0.12);
        border-color: rgba(255, 255, 255, 0.2);
      }
    }

    .v-tab--active,
    .v-tab.activeTab {
      font-weight: bold;
      border-color: var(--v-primary-base) !important;
      color: var(--v-primary-base) !important;

      .v-icon {
        color: var(--v-primary-base) !important;
      }
    }
  }
  .input-height-32 {
    .v-input__control {
      min-height: 32px !important;
    }
  }

  .task-section {
    min-width: 50%;
    flex: 1;
  }
  .customSearchBox {
    .v-input__control .v-input__slot {
      padding-right: 5px;
      .v-input__append-inner {
        margin-top: 5px !important;
        .v-input__icon--append {
          border-radius: 50%;
          background-color: var(--v-primary-base);
          width: 30px;
          height: 30px;
          i {
            color: var(--v-white-base) !important;
          }
        }
      }
    }
  }
  // .actions {
  //   .v-btn-toggle > .v-btn.v-btn {
  //     border-radius: 50%;
  //   }
  //   .v-btn-toggle > .v-btn.v-btn:first-child {
  //     border-top-left-radius: 50%;
  //     border-bottom-left-radius: 50%;
  //   }
  //   .v-btn-toggle > .v-btn.v-btn:last-child {
  //     border-top-right-radius: 50%;
  //     border-bottom-right-radius: 50%;
  //   }
  //   .v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  //     border-color: var(--v-primary-base) !important;
  //   }
  // }

  // Phase 3 of TaskBoard viewer migration
  .task-viewers-section-wrapper {
    position: relative;
    height: 100%;
    overflow: hidden;

    // Restore the absolute positioning the old TaskViewerSection.vue applied
    // via `#viewer-section-container #coloring-options`. After migration the
    // outer container changed, so this scoped rule reattaches the same offsets
    // for the slot-rendered ViewerTaskColoring overlay.
    #coloring-options {
      position: absolute;
      z-index: 2;
      top: 65px;
      left: 15px;
      padding: 8px;
      border-radius: 4px;
    }
  }

  // Phase 3 — Icon-button + corner-badge. Animation contract matches the
  // sibling .viewer-control-btn (expand/close) exactly: single 0.15s
  // color/transform transition, no compound motion, no scale-on-hover.
  // Badge is purely informational (no animation) — same as iOS / GitHub /
  // Gmail notification badges.
  .task-header-isolated-btn {
    position: relative;          // Anchors the absolute-positioned badge
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-right: 6px;
    border: none;
    border-radius: 6px;          // Matches .viewer-control-btn
    background: transparent;
    color: var(--v-primary-base);
    cursor: pointer;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    .task-header-isolated-btn__icon {
      color: var(--v-primary-base) !important;
      transition: all 0.15s ease;
    }

    &:hover {
      background: rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.15);
    }

    &:active:not(:disabled) {
      transform: scale(0.92);    // Matches .viewer-control-btn
    }

    &:focus-visible {
      outline: 2px solid var(--v-primary-base);
      outline-offset: 2px;
    }

    @media (prefers-reduced-motion: reduce) {
      transition: none;
      .task-header-isolated-btn__icon { transition: none; }
      &:active:not(:disabled) { transform: none; }
    }

    // Corner badge — static, no animation. White border creates a halo gap
    // that separates the badge from the button background even when the
    // button is hovered or pressed. Min-width grows with count (1 → 12 → 99+).
    .task-header-isolated-btn__badge {
      position: absolute;
      top: -3px;
      right: -3px;
      min-width: 18px;
      height: 18px;
      padding: 0 5px;
      background: var(--v-primary-base);
      color: white;
      border-radius: 9px;
      border: 2px solid white;
      font-size: 10px;
      font-weight: 700;
      line-height: 14px;
      text-align: center;
      letter-spacing: 0.02em;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
      pointer-events: none;        // Click passes through to the button
    }
  }

  // Dark-theme support — badge border switches to a translucent dark ring so
  // the halo reads as a separator on dark chrome.
  .theme--dark {
    .task-header-isolated-btn__badge {
      border-color: rgba(0, 0, 0, 0.35);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    }
  }
</style>
